<template>
  <main>
    <b-card border-variant="light">
      <div class="card-text">
        <div class="d-flex flex-row justify-content-between line-height-golden">
          <span class="h6 font-weight-bold text-dark">Juridisk Hotline</span>
        </div>
        <span class="d-block mt-4">
          <b-btn variant="info" @click="legalShow = !legalShow" class="rounded">Skriv til advokaten</b-btn>
        </span>
        <!-- Modal Component -->
        <b-modal lazy centered id="modal-center" ref="legalModal" lazy v-model="legalShow">
          <!-- modalHeader -->
          <div slot="modal-header" class="modal-header pt-0 w-100">
            <div class="h5 pt-2 font-weight-bold text-dark">Juridisk rådgivning</div>
            <div class="right">
              <b-btn variant="outline-dark" @click="closeLegalModal" class="border-0">
                <span><i class="el-icon-close"></i></span>
              </b-btn>
            </div>
          </div>
          <!-- modalContent -->
          <div class="d-flex justify-content-center">
            <div class="pr-4">
              <b-img src="../static/img/mst.jpg" alt="" class="rounded-circle" width="100" height="100" />
            </div>
            <div class="h6 pt-2 open-sans pr-2 pb-0 line-height-golden">Som partner kan du få gratis juridisk rådgivning pr. telefon ifm. byggesager (entrepriseret) af vores samarbejdspartner advokat Michael Stæhr.
            </div>
          </div>
          <!-- modalFooter -->
          <div slot="modal-footer" class="w-100 mt-0 pt-0 pr-2 pb-4 pl-2">
            <b-form @submit.stop.prevent="onSubmitMessageHotline" @reset="resetForm">
              <b-form-row class="pb-4">
                <b-col>
                  <b-form-textarea ref="focusLegalMessage" id="textarea1" v-model="form.text" placeholder="Beskriv din problemstilling kort" :rows="10" :max-rows="18" required></b-form-textarea>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col cols="6">
                  <b-btn type="reset" slot="modal-cancel" variant="secondary" size="lg" class="float-left rounded" @click="closeLegalModal">
                    <span class="mr2"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12-5.373-12-12-12-12 5.373-12 12zm7.58 0l5.988-5.995 1.414 1.416-4.574 4.579 4.574 4.59-1.414 1.416-5.988-6.006z"/></svg></span>Luk
                  </b-btn>
                </b-col>
                <b-col cols="6">
                  <b-btn type="submit" slot="modal-ok" class="float-right rounded" variant="success" size="lg" :disabled="isLoadingHotline">
                    Send besked
                    <span class="ml2"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.218 19l-1.782-1.75 5.25-5.25-5.25-5.25 1.782-1.75 6.968 7-6.968 7z"/></svg></span>
                  </b-btn>
                </b-col>
              </b-form-row>
            </b-form>
          </div>
        </b-modal>
      </div>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </b-card>
  </main>
</template>
<script>
import Simplert from 'vue2-simplert'
export default {
  name: 'hotlinemodal',
  components: {
    Simplert
  },
  data () {
    return {
      legalShow: false,
      isLoadingHotline: false,
      form: {
        text: ''
      }
    }
  },
  methods: {
    onSubmitMessageHotline (evt) {
      this.isLoadingHotline = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'calllawyer', salesPerson: this.salesPerson, calllawyertext: this.form.text}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.legalShow = false
              let obj = {
                title: 'udført med succes',
                message: '',
                type: 'success'
              }
              this.isLoadingHotline = false
              this.$refs.simplert.openSimplert(obj)
              this.form.text = ''
            } else {
              alert(res.message)
              this.isLoadingHotline = false
            }
          },
          response => {
            alert('error')
          }
        )
    },
    resetForm (evt) {
      evt.preventDefault()
      /* Reset our form values */
      this.form.message = ''
    },
    closeLegalModal () {
      this.$refs.legalModal.hide()
    }
  }
}
</script>


// WEBPACK FOOTER //
// HotlineModal.vue?c9b92392